import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Logistiques } from '../../logistiques';
import { LogistiquesService } from '../../logistiques.service';

@Component({
  selector: 'app-zones-vehicule',
  templateUrl: './zones-vehicule.component.html',
  styleUrls: ['./zones-vehicule.component.css']
})
export class ZonesVehiculeComponent implements OnInit, OnDestroy {
  @Input() id: string;
  subscription: Subscription = new Subscription();
  zone: Logistiques;
  vehicules: Logistiques[];
  form: FormGroup;
  submitted = false;
  errorMg = '';
  errorLoading = '';
  loading = true;

  constructor(
    private modal: NgbModal,
    private fb: FormBuilder,
    private service: LogistiquesService
  ) { }


  ngOnInit(): void {
    this.getZone(this.id);
    this.getVehicules();
    this.createForm();
  }

  getZone(id: string): void {
    this.subscription.add(
      this.service.view('zones_vehicule', id)
        .subscribe(arg => {
          this.zone = arg;
          this.loading = false;
        },
          erg => {
            this.errorLoading = 'Erreur de chargement de données';
            this.loading = false;
          }));
  }

  getVehicules(): void {
    this.subscription.add(this.service.list('vehicules')
      .subscribe(arg => {
        this.vehicules = arg;
        this.loading = false;
      },
        erg => {
          this.errorLoading = 'Erreur de chargement de données';
          this.loading = false;
        }));
  }

  open(c: any): void {
    this.modal.open(c);
  }

  createForm(): void {
    this.form = this.fb.group({
      vehicule: ['', Validators.required],
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.subscription.add(
      this.service.update('zones_vehicule', this.id, this.form.value)
        .subscribe(arg => {
          this.submitted = false;
          this.getZone(this.id);
          this.modal.dismissAll();
        },
          erg => {
            this.errorMg = erg.error.message;
            this.submitted = false;
          })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
